import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import BlankLayout from '../../components/layout/Blank';
import pageHoc from '../../hocs/pageHoc';
import MfaCodeInput from '../../components/molecules/MfaCodeInput';
import { useMfaChallenge } from './useMfaChallenge';

const pageTitle = 'Verify MFA';

const Container = styled.div`
  max-width: 440px;
  margin: 0 auto;
  padding-top: 40px;
`;

const Title = styled.h1`
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.text.dark};
`;

const Description = styled.p`
  margin: 0 0 24px;
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.main};
`;

const MfaChallenge = () => {
  const { challengeToken, verifyCode, isLoading } = useMfaChallenge();
  const [useBackupCode, setUseBackupCode] = useState(false);

  if (!challengeToken) {
    return <Redirect to="/login" />;
  }

  return (
    <BlankLayout>
      <Container>
        <Title>Check your authenticator app</Title>
        <Description>
          {useBackupCode
            ? 'Enter one of the backup codes you saved when you set up two-factor authentication.'
            : 'Enter the 6-digit code to verify your identity.'}
        </Description>
        <MfaCodeInput
          onSubmit={(code) => verifyCode(code, { useBackupCode })}
          onModeChange={setUseBackupCode}
          disabled={isLoading}
          dataCyPrefix="mfa"
        />
      </Container>
    </BlankLayout>
  );
};

export default pageHoc({ title: pageTitle })(MfaChallenge);
